import { ProfileTab } from '../enums/profile-tab.enum';

export const PROFILE_TABS_NAMES = {
    GENERAL: 'general',
    SETTINGS: 'settings',
    ADDITIONAL_PROFILES: 'additional-profiles'
};

export const PROFILE_TABS_INDICES = {
    GENERAL_TAB_INDEX: 0,
    SETTINGS_TAB_INDEX: 1,
    ADDITIONAL_PROFILES_TAB_INDEX: 2
};

export const PROFILE_TABS = new Map<string, ProfileTab>([
    [PROFILE_TABS_NAMES.GENERAL, ProfileTab.General],
    [PROFILE_TABS_NAMES.SETTINGS, ProfileTab.Settings],
    [PROFILE_TABS_NAMES.ADDITIONAL_PROFILES, ProfileTab.AdditionalProfiles],
]);